import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { format } from 'app/shared/utils/string.util';
import { IDataflowTypeMetadataSource } from 'app/extensibility/metadatas/resource-type/dataflow-format-type-metadata';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { kafkaAuthTypes, saslMechanismType } from 'shell-models-lib';

const basicAuthControls: ControlMetadata[] = [
    {
        type: 'parameterizable',
        child: {
            type: 'textbox',
            bind: 'username',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
        }
    },
    {
        type: 'dynamic-akv-switcher',
        enableAKVParameterization: true,
        hideAKVSwitcherInConnStrProps: true,
        bind: 'password',
        label: stringResources.ModelName_Password,
        child: {
            type: 'parameterizable',
            attribute: 'password',
            disableAddParameter: true,
            child:
                {
                    type: 'password',
                    label: stringResources.ModelName_Password,
                    required: true,
                    isLabelVertical: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ]
                }
        },
        description: format(
            stringResources.AzureKeyVaultSecretName_Tooltip_Template,
            format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Kafka_DisplayText),
            stringResources.ModelName_Password
        )
    }
];

const dataflowKafkaSource: IDataflowTypeMetadataSource = {
    type: DatasetFormatType.Kafka,
    displayName: stringResources.Kafka_DisplayText,
    settings: adfModelTypeMap.kafka.dataflowSettings,
    controls: []
};

const controls: ControlMetadata[] = [
    {
        type: 'parameterizable',
        child: {
            type: 'textbox',
            bind: 'bootstrapServers',
            label: stringResources.ModelName_bootstrapServers,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        }
    },
    {
        type: 'select-switch',
        bind: 'authenticationType',
        label: stringResources.ModelName_AuthenticationType,
        required: true,
        options: [
            {
                label: stringResources.SASL_displayName,
                value: kafkaAuthTypes.SASL
            }
        ],
        isLabelVertical: true,
        defaultValue: kafkaAuthTypes.SASL
    },
    {
        type: 'select-switch',
        bind: 'saslMechanism',
        label: stringResources.SASLMechanism_DisplayName,
        required: true,
        options: [
            {
                label: stringResources.PLAIN_displayName,
                value: saslMechanismType.PLAIN
            }
        ],
        isLabelVertical: true,
        defaultValue: saslMechanismType.PLAIN,
        cases: [
            {
                caseValue: saslMechanismType.PLAIN,
                children: basicAuthControls
            }
        ]
    },
];

export const kafkaMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.kafka.linkedServiceType,
    displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, stringResources.Kafka_DisplayText),
    linkedServiceKind: 'unknown',
    icon: {
        className: 'svg-i-100x100-kafka'
    },
    category: ['Streaming'],
    onlyAzureIR: true,
    copySourceTypes: [],
    copySinkTypes: [],
    isFirstClass: true,
    isCDCOnly: true,
    supportDataFlowSource: true,
    dataflowSource: [dataflowKafkaSource],
    supportFirstClassParameterExperience: true,
    controls
};
